/** На основе спецификации в https://www.xwiki.org/xwiki/bin/view/Documentation/UserGuide/Features/XWikiRESTfulAPI 
 * 
 * Связывает XWikiSDK с конкретным 
 * 
*/
import 'whatwg-fetch';
import _ from 'lodash';
import settings from './settings';
import XWikiSDK from './XWikiSDK';

function getQueryString(params) {
    const esc = encodeURIComponent;
    return _.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&');
}

const getUrl = (url, queryParams) => {
    if (_.keys(queryParams).length > 0) {
        url += `?${getQueryString(queryParams)}`;
    }
    return url;
};

const timeoutPromise = (loadTimeout) => {
    return new Promise((resolve, reject) => {
        setTimeout(
            () =>
                reject(
                    new Error({
                        message: "Connection to the Internet couldn't be established",
                    })
                ),
            loadTimeout
        );
    });
}

/**
 * Список клиентов xWiki по endpointUrl
 */
const xWikiClients = new Map();
const XWikiClient = new XWikiSDK(settings.xWikiUrl);
if (process.env.NODE_ENV === 'development') {
	XWikiClient.setAuth(settings.xwiki_username, settings.xwiki_password);
}
xWikiClients.set(settings.xWikiUrl, XWikiClient);

const ApiUtils = {

    register_endpointUrl(endpointUrl){
        xWikiClients.set(endpointUrl, new XWikiSDK(endpointUrl));
    },

    clientByEndpointUrl(endpointUrl){
        return xWikiClients.has(endpointUrl) ? xWikiClients.get(endpointUrl) : XWikiClient;
    },

    /** Возвращает список доступных Wiki */
    getWikis(options = {}){
        let {endpointUrl} = settings;
        if (options.endpointUrl) {
            endpointUrl = options.endpointUrl;
        }
        const client = this.clientByEndpointUrl(endpointUrl);
        //console.log("ApiUtils.js getWikis", options, endpointUrl, client);
        const timeout = timeoutPromise(settings.loadTimeout);
        const getData = client.wikisList().send();
        return Promise.race([timeout, getData]);
    },

    /** Возвращает список доступных пространств имён для конкретной wiki */
    getSpaces(wiki = "xwiki", options = {}){
        let {endpointUrl} = settings;
        if (options.endpointUrl) {
            endpointUrl = options.endpointUrl;
        }
        const client = this.clientByEndpointUrl(endpointUrl);
        client.setWiki(wiki);
        //console.log("ApiUtils.js getWikis", options, endpointUrl, client);
        const timeout = timeoutPromise(settings.loadTimeout);
        const getData = client.spacesList().send();
        return Promise.race([timeout, getData]);
    },
    
    fetch(xWiki, spaces=null, params = {}, options = {}) {
        //Специальный Promise для обработки таймаута
        const timeout = timeoutPromise(settings.loadTimeout);
        let {endpointUrl} = settings;
        if (options.endpointUrl) {
            // eslint-disable-next-line prefer-destructuring    
            endpointUrl = options.endpointUrl;
        }
        const client = this.clientByEndpointUrl(endpointUrl);
        client.setWiki(xWiki);
        const getData = new Promise((resolve, reject) => {
            return client.query(sparql, graph, params, options)
                .then(response => ApiUtils.checkStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([timeout, getData]);
    },

    checkStatus(response) {
        if (response.type === 'opaque') return response;
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw (response.error) ? response.error : `Ответ сервиса: ${response.statusText} (${response.status}).`;
    },
    convertToSelectOptions(list) {
        return _.map(list, obj => ({value: obj.id, label: obj.name}));
    },
    convertToSelectOption(option) {
        if (option == null || !option.id) return '';
        return {value: option.id, label: option.name};
    }
};

export default ApiUtils;
